module.exports = __webpack_public_path__ + "img/payQrcode.bca13ee8.png";